import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const routeLabels = {
  '': 'Home',
  'products': 'Products',
  'produtos': 'Produtos',
  'e-foils': 'E-Foils',
  'jetboards': 'Jetboards',
  'accessories': 'Accessories',
  'ultra-ai': 'Ultra AI',
  'blog': 'Blog',
  'faq': 'FAQ',
  'contato': 'Contato',
  'agendar': 'Agendar Aula',
  'admin': 'Admin',
};

// Pages where breadcrumbs should be visually hidden (hero covers the top)
function shouldHideVisual(pathname) {
  // Normalize: remove trailing slash
  const p = pathname.replace(/\/$/, '') || '/';
  if (p === '/') return true;
  if (p === '/products/efoils') return true;
  if (p === '/products/jetboards') return true;
  if (p === '/products/ultra-ai') return true;
  if (p === '/products/ultra_ai') return true;
  if (p.startsWith('/products/SharkX-Ultra-AI')) return true;
  if (p === '/ultra-ai') return true;
  if (p === '/home-final') return true;
  return false;
}

function Breadcrumbs() {
  const location = useLocation();
  const pathSnippets = location.pathname.split('/').filter(Boolean);
  const hideVisual = shouldHideVisual(location.pathname);
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://staging.sharkxelectric.com';

  const crumbs = pathSnippets.map((snippet, i) => {
    const url = '/' + pathSnippets.slice(0, i + 1).join('/');
    const label = routeLabels[snippet] || decodeURIComponent(snippet);
    return { url, label };
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `${origin}/`,
      },
      ...crumbs.map((c, i) => ({
        '@type': 'ListItem',
        position: i + 2,
        name: c.label,
        item: origin + c.url,
      })),
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      {!hideVisual && crumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="text-xs text-gray-500 px-4 py-2 max-w-7xl mx-auto">
          <Link to="/" className="hover:text-gray-800 transition-colors">Home</Link>
          {crumbs.map((c, i) => (
            <React.Fragment key={c.url}>
              <span className="mx-1">/</span>
              {i === crumbs.length - 1 ? (
                <span className="text-gray-800 font-medium">{c.label}</span>
              ) : (
                <Link to={c.url} className="hover:text-gray-800 transition-colors">{c.label}</Link>
              )}
            </React.Fragment>
          ))}
        </nav>
      )}
    </>
  );
}

export default Breadcrumbs;
